module.exports = __webpack_public_path__ + "img/home-industry-body-1.db0074ed.png";